// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
import type { PropsWithChildren } from 'react';

import { useThemeGenerator } from '../../hooks';
import { KioskThemeProvider } from '../../providers';
import { mobileTypographyVariants } from '../../util';
import { Layout } from './Layout/Layout';

export const MobileLayout = ({ children }: PropsWithChildren) => {
  const theme = useTheme();
  const mobileTheme = useThemeGenerator(theme.colors.primary.main, {
    components: {
      Typography: { fonts: {}, variants: mobileTypographyVariants },
    },
  });
  return (
    <KioskThemeProvider theme={mobileTheme} themeId="mobile-theme">
      <Layout id="mobile-theme" passwordProtected={false}>
        {children}
      </Layout>
    </KioskThemeProvider>
  );
};
